import {forwardRef, useMemo} from "react";
import {Project} from "../../../../api/Projects";
import {Company} from "../../../../api/Companies";
import {Contact} from "../../../../api/Contacts";
import {InventoryRequest} from "../../../../api/Logistics";
import {PDF} from "../../../../misc/pdf/parts/PDF";
import {CoverPage} from "../../../../misc/pdf/parts/CoverPage";
import {ContainerPage} from "../../../../misc/pdf/parts/ContainerPage";
import {TitleTextBlock} from "../../../../misc/pdf/parts/TitleTextBlock";
import {ClientInfoContextProvider, PDFProjectContext} from "../openings/OpeningsPDF";
import {PdfTableServerRendered} from "../openings/pdf/PdfTableServerRendered";
import {useReadyCheck} from "../../../../misc/pdf/UseReadyCheck";
import {PageRenderProvider} from "../../../../misc/pdf/parts/PageContext";
import {hasPreambleContent, preambleToBlocks} from "../../../../misc/richtext/preambleContent";
import {LogisticsExportColumn} from "./LogisticsRecordsSubmittal";

export const LogisticsRecordsPDF = forwardRef(function(props: {
    project: Project;
    client?: Company;
    clientContact?: Contact;
    lastSubmittal: string | null;
    title: string;
    notes: string;
    columns: LogisticsExportColumn[];
    data: InventoryRequest[];
    onReady(): void;
}, ref: any) {
    const ready = useReadyCheck(props.onReady);
    ready.require(true);

    const notes = useMemo(() => preambleToBlocks(props.notes || ""), [props.notes]);

    const table = {
        header: props.columns.map(c => c.display),
        content: props.data.map(d => props.columns.map(c => {
            if(c.render) return c.render(d);
            return (d as any)[c.key]?.toString() || "";
        })),
    };

    return (
        <div ref={ref}>
        <PDF>
            <PDFProjectContext.Provider value={props.project}>
                <ClientInfoContextProvider client={props.client} clientContact={props.clientContact}>
                    <CoverPage title={props.title} lastSubmittal={props.lastSubmittal} />
                    {hasPreambleContent(props.notes) && <PageRenderProvider data={notes} onReady={ready.section()}>
                        {info =>
                            <ContainerPage>
                                <TitleTextBlock title="NOTES">
                                    {info.rows.map((d, index) => <div key={index.toString()} dangerouslySetInnerHTML={{__html: d}} />)}
                                </TitleTextBlock>
                            </ContainerPage>}
                    </PageRenderProvider>}
                    <PdfTableServerRendered value={table} />
                </ClientInfoContextProvider>
            </PDFProjectContext.Provider>
        </PDF>
        </div>
    )
})
